
import { Link } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useAuth } from "@/contexts/AuthContext";
import { useProfile } from "@/contexts/ProfileContext";
import { Loader2, User2 } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";

export function MobileProfileMenu() {
  const { user, signOut } = useAuth();
  const { profile, isLoading } = useProfile();
  const { toast } = useToast();
  const navigate = useNavigate();

  if (!user) {
    return <Link to="/login" className="flex items-center gap-2 p-4 rounded-sm">
      <Avatar className="h-6 w-6">
        <AvatarFallback>
          <User2 className="h-4 w-4" />
        </AvatarFallback>
      </Avatar>
      <span>Sign in / Create Account</span>
    </Link>;
  }

  const userInitial = profile?.full_name?.[0]?.toUpperCase() || user.email?.[0]?.toUpperCase() || '?';
  const isCandidate = profile?.role === 'candidate';

  const handleSignOut = async () => {
    try {
      await signOut();
      toast({
        title: "Signed out successfully",
        className: "bg-card border-none text-foreground"
      });
      navigate("/"); // Redirect to landing page
    } catch (error) {
      console.error('Sign out error:', error);
      toast({
        title: "Error signing out",
        description: "Please try again",
        className: "bg-card border-none text-foreground"
      });
    }
  };

  if (isLoading) {
    return <div className="flex items-center gap-2 p-4 rounded-sm">
      <Avatar className="h-10 w-10">
        <AvatarFallback className="bg-secondary text-secondary-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
        </AvatarFallback>
      </Avatar>
      <span className="text-muted-foreground">Loading...</span>
    </div>;
  }

  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-3 p-4 border-b border-border">
        <Avatar className="h-10 w-10">
          <AvatarImage src={profile?.avatar_url} />
          <AvatarFallback className="bg-secondary text-secondary-foreground">
            {userInitial}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col">
          <div className="font-medium text-base text-foreground">
            {profile?.full_name || 'User'}
          </div>
          <div className="text-sm text-muted-foreground truncate">
            {user.email}
          </div>
          {profile?.role && <div className="text-xs mt-1 px-2 py-0.5 rounded-full bg-primary/10 text-primary inline-block">
            {profile.role.charAt(0).toUpperCase() + profile.role.slice(1)}
          </div>}
        </div>
      </div>

      <div className="flex flex-col mt-4 space-y-1">
        <Link to="/profile" className="px-4 py-3 cursor-pointer text-base hover:bg-accent rounded-sm text-foreground">
          My Profile
        </Link>
        
        <div className="h-px bg-border my-2 mx-4" />
        
        <button 
          onClick={handleSignOut} 
          className="px-4 py-3 cursor-pointer text-base hover:bg-accent rounded-sm text-foreground text-left"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
